import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight, Search } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';

export const QUICK_ASK_EVENT = 'qflow:quick-ask';
const typingIn = (target) => Boolean(target?.closest?.('input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"]'));

// Press / on any page (Ctrl+K stays with the Copilot): type a question and go straight to the answer.
const QuickAsk = () => {
  const navigate = useNavigate();
  const input = useRef(null);
  const [open, setOpen] = useState(false);
  const [question, setQuestion] = useState('');

  useEffect(() => {
    const onKey = (event) => {
      if (!event.defaultPrevented && !event.isComposing && !event.repeat && !event.target?.closest?.('[role="dialog"], [role="alertdialog"]') && event.key === '/' && !event.ctrlKey && !event.metaKey && !event.altKey && !typingIn(event.target)) {
        event.preventDefault();
        setOpen(true);
      }
    };
    const onOpen = () => setOpen(true);
    window.addEventListener('keydown', onKey);
    window.addEventListener(QUICK_ASK_EVENT, onOpen);
    return () => { window.removeEventListener('keydown', onKey); window.removeEventListener(QUICK_ASK_EVENT, onOpen); };
  }, []);

  const submit = (event) => {
    event.preventDefault();
    const text = question.trim();
    if (!text) return;
    setOpen(false);
    setQuestion('');
    navigate('/query', { state: { question: text, autoSubmit: true } });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-xl p-0" onOpenAutoFocus={(event) => { event.preventDefault(); input.current?.focus(); }}>
        <DialogTitle className="sr-only">Ask Qflow</DialogTitle>
        <form onSubmit={submit} className="flex items-center gap-2 p-3 pr-12" data-testid="quick-ask">
          <Search size={18} className="shrink-0 text-gray-400" aria-hidden="true" />
          <input ref={input} value={question} onChange={(event) => setQuestion(event.target.value)} maxLength={2000} placeholder="Ask about a process, policy or next step" aria-label="Ask Qflow" className="h-11 min-w-0 flex-1 border-0 bg-transparent text-[15px] outline-none" data-testid="quick-ask-input" />
          <button type="submit" className="qflow-accent-bg flex h-9 items-center gap-1.5 rounded-lg px-3 text-sm font-semibold">Ask<ArrowUpRight size={14} aria-hidden="true" /></button>
        </form>
        <p className="border-t px-4 py-2 text-xs text-gray-500" style={{ borderColor: 'var(--qflow-border)' }}>Press Enter to ask. Press / on any page to open this.</p>
      </DialogContent>
    </Dialog>
  );
};

export default QuickAsk;
